import { gql, MutationHookOptions, QueryHookOptions, useMutation } from '@apollo/client';
import {
  AcknowledgeV2UpgradeMutation,
  AcknowledgeV2UpgradeMutationVariables,
  LatestDataModelV2UpgradeJobQuery,
  LatestDataModelV2UpgradeJobQueryVariables,
  RunDataModelV2UpgradeJobMutation,
  RunDataModelV2UpgradeJobMutationVariables,
} from '../../graphql/types';
import { useQueryAndRefetchOnUserChange } from '../../lib/hooks';

const DATA_MODEL_V2_UPGRADE_JOB_FIELDS = gql`
  fragment DataModelV2UpgradeJobFields on DataModelV2UpgradeJob {
    id
    createdAt
    updatedAt
    status
    stage
    jobData
    errorMessage
  }
`;

const LATEST_DATA_MODEL_V2_UPGRADE_JOB = gql`
  ${DATA_MODEL_V2_UPGRADE_JOB_FIELDS}
  query LatestDataModelV2UpgradeJob {
    latestDataModelV2UpgradeJob {
      ...DataModelV2UpgradeJobFields
    }
  }
`;

export function useLatestDataModelV2UpgradeJob(
  options?: QueryHookOptions<LatestDataModelV2UpgradeJobQuery, LatestDataModelV2UpgradeJobQueryVariables>,
) {
  return useQueryAndRefetchOnUserChange<
    LatestDataModelV2UpgradeJobQuery,
    LatestDataModelV2UpgradeJobQueryVariables
  >(LATEST_DATA_MODEL_V2_UPGRADE_JOB, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    ...options,
  });
}

const RUN_DATA_MODEL_V2_UPGRADE_JOB = gql`
  ${DATA_MODEL_V2_UPGRADE_JOB_FIELDS}
  mutation RunDataModelV2UpgradeJob {
    runDataModelV2UpgradeJob {
      ...DataModelV2UpgradeJobFields
    }
  }
`;

export function useRunDataModelV2UpgradeJob(
  options?: MutationHookOptions<RunDataModelV2UpgradeJobMutation, RunDataModelV2UpgradeJobMutationVariables>,
) {
  return useMutation<RunDataModelV2UpgradeJobMutation, RunDataModelV2UpgradeJobMutationVariables>(
    RUN_DATA_MODEL_V2_UPGRADE_JOB,
    options,
  );
}

export const HAS_UNLOCKED_SPEC_ID_V1_DATA = gql`
  query HasUnlockedSpecIdV1Data {
    hasUnlockedSpecIdV1Data
  }
`;

const ACKNOWLEDGE_V2_UPGRADE = gql`
  mutation AcknowledgeV2Upgrade {
    acknowledgeV2Upgrade
  }
`;

export function useAcknowledgeV2Upgrade(
  options?: MutationHookOptions<AcknowledgeV2UpgradeMutation, AcknowledgeV2UpgradeMutationVariables>,
) {
  return useMutation<AcknowledgeV2UpgradeMutation, AcknowledgeV2UpgradeMutationVariables>(
    ACKNOWLEDGE_V2_UPGRADE,
    options,
  );
}
